export default __webpack_public_path__ + "static/media/hello-fresh-logo.fb63ca6f.webp";